/** 자료실 탭 게시판 — 정적 샘플(추후 CMS 연동 시 교체). */

export type ResourceCategory = 'notice' | 'law' | 'docs' | 'news';

export type ResourceTab = 'all' | ResourceCategory;

export type ResourceItem = {
  id: string;
  category: ResourceCategory;
  title: string;
  summary: string;
  detail: string;
};

export const RESOURCE_ITEMS: ResourceItem[] = [
  {
    id: 'n1',
    category: 'notice',
    title: 'EV123 전기차충전기 설치검토 서비스 안내',
    summary:
      'EV123은 공동주택, 상업시설, 업무시설, 공공시설의 전기차충전기 신규설치·교체설치·이전설치 검토를 지원합니다.',
    detail:
      '주차면 수, 시설 유형, 설치 목적, 운영방식에 따라 필요한 충전기 대수와 설치 가능 위치가 달라질 수 있습니다. EV123에서 먼저 기본 조건을 확인해보세요.',
  },
  {
    id: 'n2',
    category: 'notice',
    title: '전기차충전기 설치·운영 상담 접수 안내',
    summary:
      '전기차충전기 설치, 추가설치, 노후 충전기 교체, 충전구역 이전, 운영관리 상담을 접수합니다.',
    detail:
      '관리사무소, 건물주, 입주자대표회의, 공공기관 담당자는 상담 신청을 통해 건물 조건에 맞는 설치 방향과 운영방식을 안내받을 수 있습니다.',
  },
  {
    id: 'l1',
    category: 'law',
    title: '친환경자동차법 전기차충전시설 의무설치 기준',
    summary: '전기차충전시설 의무설치 대상과 설치 비율을 확인할 때 필요한 기본 법령 정보입니다.',
    detail:
      '공동주택과 다중이용시설은 법정 기준에 따라 전기차충전시설과 전용주차구역 설치 여부를 검토해야 합니다. 시설 유형과 기존 건축물 여부에 따라 적용 기준이 달라질 수 있습니다.',
  },
  {
    id: 'l2',
    category: 'law',
    title: '전기차충전구역 및 전용주차구역 설치 기준',
    summary: '전기차충전구역, 전용주차구역, 일반 주차면의 차이를 이해하기 위한 자료입니다.',
    detail:
      '전기차충전기 설치 시 충전시설만 보는 것이 아니라 전용주차구역, 안전동선, 표시 기준, 이용자 안내까지 함께 검토해야 합니다.',
  },
  {
    id: 'l3',
    category: 'law',
    title: '전기차충전시설 미설치·미이행 관련 유의사항',
    summary: '의무설치 대상 시설이 설치 기준을 충족하지 못할 경우 확인해야 할 행정 유의사항입니다.',
    detail:
      '전기차충전시설 의무설치와 관련한 유예기간, 이행 기준, 지자체 안내는 시기별로 달라질 수 있습니다. 실제 적용 여부는 관할 지자체와 최신 공고를 함께 확인해야 합니다.',
  },
  {
    id: 'd1',
    category: 'docs',
    title: '입주자대표회의 전기차충전기 설치 안건 예시',
    summary: '공동주택에서 전기차충전기 설치를 논의할 때 활용할 수 있는 회의 안건 예시입니다.',
    detail:
      '설치 필요성, 법정 기준, 설치 방식, 운영 방식, 사업자 비교, 입주민 안내사항을 회의자료 형태로 정리할 때 참고할 수 있습니다.',
  },
  {
    id: 'd2',
    category: 'docs',
    title: '전기차충전기 설치 전 관리사무소 체크리스트',
    summary: '전기차충전기 설치 전 관리사무소가 확인해야 할 주요 항목을 정리한 실무자료입니다.',
    detail:
      '주차면 수, 전기실 위치, 기존 충전기 현황, 입주민 민원 가능성, 충전사업자 조건, 유지보수 기준을 사전에 확인하면 설치 과정의 시행착오를 줄일 수 있습니다.',
  },
  {
    id: 'd3',
    category: 'docs',
    title: '기설치 충전기 교체·이전 검토자료',
    summary: '노후 충전기 교체, 위치 이전, 운영사업자 변경을 검토할 때 필요한 기준을 정리한 자료입니다.',
    detail:
      '기존 충전기의 사용연수, 고장 빈도, 위치 적정성, 운영사업자 대응, 이용자 불편사항을 기준으로 교체설치 또는 이전설치 필요성을 검토할 수 있습니다.',
  },
  {
    id: 'w1',
    category: 'news',
    title: '2026년 전기차충전기 보조사업 동향',
    summary: '전기차충전기 보조사업과 설치 지원 방향을 확인할 때 참고할 수 있는 시장동향 자료입니다.',
    detail:
      '보조사업은 사업 공고, 예산, 지원 대상, 의무운영기간에 따라 조건이 달라질 수 있습니다. 설치를 검토하는 시설은 신청 전 최신 공고 확인이 필요합니다.',
  },
  {
    id: 'w2',
    category: 'news',
    title: '공동주택 전기차충전기 화재예방·운영관리 이슈',
    summary: '공동주택에서 전기차충전기를 운영할 때 함께 검토해야 할 안전관리 이슈입니다.',
    detail:
      '충전기 위치, 소방 접근성, 장기충전 관리, 이용자 안내, 장애 대응 체계를 함께 검토하면 설치 이후 민원과 운영 리스크를 줄일 수 있습니다.',
  },
  {
    id: 'w3',
    category: 'news',
    title: '수익형 전기차충전기 설치 검토 포인트',
    summary: '상가, 업무시설, 공영주차장 등에서 수익형 충전기를 검토할 때 확인해야 할 핵심 요소입니다.',
    detail:
      '입지, 방문객 체류시간, 주차 회전율, 주변 충전시설, 전기공사 조건, 운영수수료를 함께 비교해야 수익형 설치 가능성을 판단할 수 있습니다.',
  },
];

export function resourceCategoryLabel(c: ResourceCategory): string {
  switch (c) {
    case 'notice':
      return '공지사항';
    case 'law':
      return '법령정보';
    case 'docs':
      return '업무자료실';
    case 'news':
      return '관련뉴스';
  }
}

/** 자료실 행 카테고리 배지 — `app.css` `.ev123-badge` + `.ev123-badge--notice|law|docs|news` */
export function resourceCategoryBadgeClasses(c: ResourceCategory): string {
  return `ev123-badge ev123-badge--${c}`;
}
